export const translations = {
  en: {
    nav: {
      home: 'HOME',
      about: 'ABOUT US',
      services: 'SERVICES',
      hybrid: 'HYBRID SPECIALIST',
      gallery: 'GALLERY',
      why: 'WHY CHOOSE US',
      reviews: 'REVIEWS',
      faq: 'FAQ',
      contact: 'CONTACT US'
    },
    hero: {
      title: 'European & Hybrid Vehicle Specialists',
      subtitle: 'Professional Diagnostics, Repair, Maintenance & Hybrid Battery Solutions',
      cta1: 'Book Appointment',
      cta2: 'WhatsApp Us',
      cta3: 'Call Now'
    },
    about: {
      title: 'About Us',
      heading: 'Your Trusted Automotive Partner',
      description: 'LENG KEE AUTO SERVICE CENTRE SDN BHD has extensive experience in automotive diagnostics, repair and maintenance services. We specialize in European luxury vehicles and hybrid technology.',
      specialties: 'We Specialize In:',
      values: 'Our Core Values',
      integrity: 'Integrity',
      quality: 'Quality',
      professionalism: 'Professionalism',
      satisfaction: 'Customer Satisfaction'
    },
    services: {
      title: 'Our Services',
      heading: 'Professional Automotive Services',
      europeanRepair: 'European Car Repair',
      diagnostics: 'Advanced Diagnostics',
      maintenance: 'Preventive Maintenance',
      hybrid: 'Hybrid Vehicle Services',
      engineRepair: 'Engine Repair',
      transmissionRepair: 'Transmission Repair',
      coolingSystem: 'Cooling System Repair',
      suspension: 'Suspension Repair',
      brakeSystem: 'Brake System Repair',
      engineDiag: 'Engine Diagnostics',
      electricalDiag: 'Electrical Diagnostics',
      ecuDiag: 'ECU Diagnostics',
      warningLight: 'Warning Light Diagnostics',
      coding: 'Coding & Programming',
      oilService: 'Engine Oil Service',
      majorService: 'Major Service',
      acService: 'Air Conditioning Service',
      brakeFluid: 'Brake Fluid Service',
      transService: 'Transmission Service',
      batteryDiag: 'Hybrid Battery Diagnosis',
      batteryRepair: 'Hybrid Battery Repair',
      batteryReplace: 'Hybrid Battery Replacement',
      systemInspection: 'Hybrid System Inspection',
      hvTesting: 'High Voltage System Testing'
    },
    engineSection: {
      title: 'ENGINE MAINTENANCE',
      description: 'We provide expert engine maintenance and repair services to ensure your vehicle performs at its best. Our experienced technicians use advanced tools and genuine parts for reliable and long-lasting results.',
      item1: 'Engine Repair & Overhaul',
      item2: 'Engine Diagnostics',
      item3: 'Oil Leak Repair',
      item4: 'Performance Tuning',
      item5: 'Regular Maintenance',
      learnMore: 'LEARN MORE'
    },
    why: {
      title: 'Why Choose Us',
      experienced: 'Experienced Technicians',
      experiencedDesc: 'Certified professionals with years of expertise',
      equipment: 'Advanced Diagnostic Equipment',
      equipmentDesc: 'State-of-the-art tools and technology',
      specialist: 'European Vehicle Specialists',
      specialistDesc: 'Expert knowledge in luxury European brands',
      hybridExpert: 'Hybrid Vehicle Experts',
      hybridExpertDesc: 'Specialized in hybrid battery systems',
      pricing: 'Transparent Pricing',
      pricingDesc: 'No hidden fees, honest quotes',
      support: 'Professional After-Sales Support',
      supportDesc: 'Continued service and assistance'
    },
    brands: {
      title: 'Brands We Service',
      subtitle: 'Expert Service for Premium Automotive Brands'
    },
    gallery: {
      title: 'Gallery',
      heading: 'Our Workshop & Services',
      facilities: 'Workshop Facilities',
      equipment: 'Diagnostic Equipment',
      process: 'Repair Process',
      hybrid: 'Hybrid Services'
    },
    reviews: {
      title: 'Customer Reviews',
      heading: 'What Our Customers Say',
      rating: 'Google Rating'
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'How long does vehicle diagnosis take?',
      a1: 'Standard diagnostic procedures typically take 1-2 hours. Complex issues may require additional time for thorough analysis.',
      q2: 'Do you repair hybrid batteries?',
      a2: 'Yes, we specialize in hybrid battery diagnosis, repair, and replacement for all major hybrid vehicle brands including Toyota, Lexus, and Honda.',
      q3: 'Do you provide warranty?',
      a3: 'We provide warranty coverage on parts and labor. Warranty periods vary depending on the service performed and parts used.',
      q4: 'Can I make an appointment online?',
      a4: 'Yes, you can contact us via WhatsApp or our contact form to schedule an appointment. We will respond promptly to confirm your booking.',
      q5: 'Do you service European vehicles?',
      a5: 'Absolutely! We specialize in European vehicles including Mercedes-Benz, BMW, Audi, Volkswagen, and Mini Cooper with certified technicians and specialized equipment.'
    },
    contact: {
      title: 'Contact Us',
      heading: 'Get In Touch',
      subheading: 'Visit us or send us a message',
      address: 'Address',
      phone: 'Phone',
      hours: 'Business Hours',
      hoursValue: 'Monday – Saturday: 8:30 AM – 5:30 PM',
      formTitle: 'Send Us A Message',
      name: 'Your Name',
      phoneLabel: 'Phone Number',
      email: 'Email (Optional)',
      vehicle: 'Vehicle Make/Model',
      service: 'Service Required',
      message: 'Additional Message (Optional)',
      submit: 'Submit Enquiry',
      submitting: 'Sending...',
      success: 'Thank you! We will contact you soon.',
      error: 'Failed to send. Please try WhatsApp instead.'
    },
    footer: {
      about: 'About',
      aboutDesc: 'Professional automotive service centre specializing in European and Hybrid vehicles in Muar, Johor.',
      quickLinks: 'Quick Links',
      servicesTitle: 'Services',
      contactTitle: 'Contact',
      rights: 'All rights reserved.',
      tagline: 'European & Hybrid Vehicle Specialists'
    }
  },
  zh: {
    nav: {
      home: '首页',
      about: '关于我们',
      services: '服务项目',
      hybrid: '混合动力专家',
      gallery: '图库',
      why: '为何选择我们',
      reviews: '客户评价',
      faq: '常见问题',
      contact: '联系我们'
    },
    hero: {
      title: '欧洲与混合动力汽车专家',
      subtitle: '专业诊断、维修、保养与混合动力电池解决方案',
      cta1: '预约服务',
      cta2: 'WhatsApp 咨询',
      cta3: '立即致电'
    },
    about: {
      title: '关于我们',
      heading: '您值得信赖的汽车服务伙伴',
      description: '龙记汽车服务中心有限公司在汽车诊断、维修和保养服务方面拥有丰富的经验。我们专注于欧洲豪华车辆和混合动力技术。',
      specialties: '我们的专业领域：',
      values: '我们的核心价值',
      integrity: '诚信',
      quality: '品质',
      professionalism: '专业',
      satisfaction: '客户满意度'
    },
    services: {
      title: '服务项目',
      heading: '专业汽车服务',
      europeanRepair: '欧洲汽车维修',
      diagnostics: '高级诊断',
      maintenance: '预防性保养',
      hybrid: '混合动力车辆服务',
      engineRepair: '引擎维修',
      transmissionRepair: '变速箱维修',
      coolingSystem: '冷却系统维修',
      suspension: '悬挂系统维修',
      brakeSystem: '刹车系统维修',
      engineDiag: '引擎诊断',
      electricalDiag: '电气系统诊断',
      ecuDiag: 'ECU 诊断',
      warningLight: '警告灯诊断',
      coding: '编程与设定',
      oilService: '机油更换服务',
      majorService: '大保养',
      acService: '空调系统服务',
      brakeFluid: '刹车油更换',
      transService: '变速箱保养',
      batteryDiag: '混合动力电池诊断',
      batteryRepair: '混合动力电池维修',
      batteryReplace: '混合动力电池更换',
      systemInspection: '混合动力系统检测',
      hvTesting: '高压系统测试'
    },
    engineSection: {
      title: '引擎维护',
      description: '我们提供专业的引擎维护和维修服务，确保您的车辆发挥最佳性能。我们经验丰富的技师使用先进工具和原装零件，确保可靠耐用的效果。',
      item1: '引擎维修与大修',
      item2: '引擎诊断',
      item3: '机油泄漏维修',
      item4: '性能调校',
      item5: '定期保养',
      learnMore: '了解更多'
    },
    why: {
      title: '为什么选择我们',
      experienced: '经验丰富的技师',
      experiencedDesc: '拥有多年专业经验的认证技师',
      equipment: '先进的诊断设备',
      equipmentDesc: '最先进的工具和技术',
      specialist: '欧洲车辆专家',
      specialistDesc: '精通欧洲豪华品牌的专业知识',
      hybridExpert: '混合动力专家',
      hybridExpertDesc: '专精于混合动力电池系统',
      pricing: '透明定价',
      pricingDesc: '无隐藏费用，诚实报价',
      support: '专业售后支持',
      supportDesc: '持续的服务和协助'
    },
    brands: {
      title: '服务品牌',
      subtitle: '为高端汽车品牌提供专业服务'
    },
    gallery: {
      title: '图库',
      heading: '我们的车间与服务',
      facilities: '车间设施',
      equipment: '诊断设备',
      process: '维修过程',
      hybrid: '混合动力服务'
    },
    reviews: {
      title: '客户评价',
      heading: '客户的声音',
      rating: 'Google 评分'
    },
    faq: {
      title: '常见问题',
      q1: '车辆诊断需要多长时间？',
      a1: '标准诊断程序通常需要 1-2 小时。复杂问题可能需要额外时间进行全面分析。',
      q2: '你们维修混合动力电池吗？',
      a2: '是的，我们专精于所有主要混合动力车辆品牌的电池诊断、维修和更换，包括丰田、雷克萨斯和本田。',
      q3: '你们提供保修吗？',
      a3: '我们为零件和人工提供保修。保修期根据所执行的服务和使用的零件而有所不同。',
      q4: '可以在线预约吗？',
      a4: '可以，您可以通过 WhatsApp 或我们的联系表格预约。我们会迅速回复确认您的预约。',
      q5: '你们维修欧洲车辆吗？',
      a5: '当然！我们专精于欧洲车辆，包括奔驰、宝马、奥迪、大众和迷你库珀，拥有认证技师和专业设备。'
    },
    contact: {
      title: '联系我们',
      heading: '联系方式',
      subheading: '欢迎来访或留言',
      address: '地址',
      phone: '电话',
      hours: '营业时间',
      hoursValue: '星期一至星期六：上午 8:30 – 下午 5:30',
      formTitle: '发送消息',
      name: '您的姓名',
      phoneLabel: '电话号码',
      email: '电子邮件（可选）',
      vehicle: '车辆品牌/型号',
      service: '所需服务',
      message: '附加信息（可选）',
      submit: '提交咨询',
      submitting: '发送中...',
      success: '谢谢！我们会尽快联系您。',
      error: '发送失败。请尝试使用 WhatsApp 联系。'
    },
    footer: {
      about: '关于',
      aboutDesc: '专业的汽车服务中心，专精于柔佛麻坡的欧洲与混合动力车辆。',
      quickLinks: '快速链接',
      servicesTitle: '服务',
      contactTitle: '联系',
      rights: '版权所有。',
      tagline: '欧洲与混合动力汽车专家'
    }
  }
};